import * as z from 'zod';

import { AudienceSchema } from 'types/pages/audience-builder/dashboard/sort/form/audience-sort-schema';

export const SortFormSchema = z.object({
  shops: z.array(AudienceSchema),
  toggle: z.boolean(),
});
